import { c as _c } from "react-compiler-runtime";
import { cva, type VariantProps } from "class-variance-authority";
import * as React from "react";
import { cn } from "@/core/utils";
const badgeVariants = cva("inline-flex items-center justify-center rounded-full border font-sans text-xs font-medium", {
  variants: {
    tone: {
      default: "bg-secondary/60 text-foreground border-border/60",
      accent: "bg-accent/10 text-accent border-accent/20",
      primary: "bg-primary/60 text-primary border-primary/20",
      success: "bg-success/10 text-success border-success/20"
    },
    size: {
      sm: "px-2.5 py-0.5",
      md: "px-3 py-1"
    }
  },
  defaultVariants: {
    tone: "default",
    size: "md"
  }
});
export interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement>, VariantProps<typeof badgeVariants> {
  icon?: React.ReactNode;
}
export function Badge(t0) {
  const $ = _c(17);
  let children;
  let className;
  let icon;
  let props;
  let size;
  let tone;
  if ($[0] !== t0) {
    ({
      className,
      tone,
      size,
      icon,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = icon;
    $[4] = props;
    $[5] = size;
    $[6] = tone;
  } else {
    children = $[1];
    className = $[2];
    icon = $[3];
    props = $[4];
    size = $[5];
    tone = $[6];
  }
  let t1;
  if ($[7] !== className || $[8] !== icon || $[9] !== size || $[10] !== tone) {
    t1 = cn(badgeVariants({
      tone,
      size
    }), icon && "gap-1.5", className);
    $[7] = className;
    $[8] = icon;
    $[9] = size;
    $[10] = tone;
    $[11] = t1;
  } else {
    t1 = $[11];
  }
  let t2;
  if ($[12] !== children || $[13] !== icon || $[14] !== props || $[15] !== t1) {
    t2 = <span className={t1} {...props}>{icon}{children}</span>;
    $[12] = children;
    $[13] = icon;
    $[14] = props;
    $[15] = t1;
    $[16] = t2;
  } else {
    t2 = $[16];
  }
  return t2;
}